import authApi from '_api/auth'
import axiosClient from '_api/axiosClient'
import userApi from '_api/user'
import { useModal } from '_hooks/useModal'
import { parseJwt } from '_utils/function'
import { setUserToken } from '_utils/localData'
import { useGuestCreateAccount } from './useGuestCreateAccount'

export const useShareGuestAccount = ({
  guestFormData,
  eventDetail,
  addressBook,
  submission,
  setUserInfo,
}) => {
  const {
    isOpen: isRegisterModalOpen,
    openModal: openRegisterModal,
    closeModal: closeRegisterModal,
  } = useModal()

  const {
    isOpen: isNotifyPopupOpen,
    openModal: openNotifyPopup,
    closeModal: closeNotifyPopup,
  } = useModal()

  const {
    registerWithPIN,
    registerWithGoogle,
    isSubmitting: isRegisterSubmitting,
  } = useGuestCreateAccount()

  const checkExistingGuestUser = async () => {
    const email = guestFormData?.email?.toLowerCase().trim()
    if (!email) return false
    try {
      const res = await authApi.searchUser(email)
      if (res?.msgResp?.uid) {
        openNotifyPopup()
        return true
      }
    } catch (_error) {
      // Keep current guest checkout flow if lookup fails
    }
    return false
  }

  const handleAccountCreated = async (token) => {
    closeRegisterModal()
    if (token) {
      setUserToken(token)
      const parsedUserInfo = parseJwt(token)
      axiosClient.defaults.headers.common.Authorization = `Bearer ${token}`
      try {
        const res = await userApi.getUserById(parsedUserInfo?.id)
        const fullUserInfo = res?.msgResp || parsedUserInfo
        setUserInfo(fullUserInfo)
      } catch (err) {
        setUserInfo(parsedUserInfo)
      }

      if (eventDetail.bookingAddressRequired) {
        if (!addressBook.userAddresses || addressBook.userAddresses.length === 0) {
          addressBook.handleOpenAddNewAddress()
        } else {
          addressBook.toggleChangeAddressModal()
        }
      } else {
        await submission.proceedWithOrder(null, guestFormData?.noteToHost || null)
      }
    }
  }

  const handleRegisterPIN = async (pin) => {
    const token = await registerWithPIN({ guestFormData, pin })
    if (token) {
      await handleAccountCreated(token)
    }
  }

  const handleRegisterGoogle = async (googleResponse) => {
    const token = await registerWithGoogle({ googleResponse, guestFormData })
    if (token) {
      await handleAccountCreated(token)
    }
  }

  return {
    isRegisterModalOpen,
    openRegisterModal,
    closeRegisterModal,
    isNotifyPopupOpen,
    openNotifyPopup,
    closeNotifyPopup,
    isRegisterSubmitting,
    checkExistingGuestUser,
    handleRegisterPIN,
    handleRegisterGoogle,
  }
}
